<template lang="pug">
	//- Индикаторы ожидания в конце истории чата
	.ai-chat-indicators
		//- Индикатор распознавания голосового сообщения: аудио отправлено на сервер и далее в OpenRouter, пока не получен текст
		.ai-chat-message.assistant.thinking(v-if="transcribing")
			.ai-chat-message-content
				i.fa.fa-spinner.fa-spin
				span Transcribing voice message...
		//- Индикатор работы агента: показывается весь цикл общения с моделью, пока не применены все действия
		.ai-chat-message.assistant.thinking(v-if="thinking")
			.ai-chat-message-content
				i.fa.fa-spinner.fa-spin
				span {{stopping ? 'Stopping...' : 'Thinking...'}}
				//- Досрочная остановка работы агента (доступна, когда чат уже создан на сервере)
				button.ai-chat-stop-button(type="button" :disabled="stopping || !chat" v-on:click="$emit('stop')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Stop the AI agent. Changes made before the stop are kept'}")
					i.fa.fa-times
</template>

<script>
	export default {
		name: "AIAgentIndicators",
		props: ['chat', 'thinking', 'stopping', 'transcribing']
	}
</script>

<style lang="sass">

	.ai-chat
		.ai-chat-history
			.ai-chat-message
				// Индикатор работы агента
				&.thinking
					.ai-chat-message-content
						display: flex
						flex-direction: row
						align-items: center
						gap: 8px
						color: #adb6bf
						user-select: none

						i.fa
							color: #20a8d8

						// Кнопка остановки - красный крестик без фона, с увеличенной (за счёт padding) областью нажатия.
						// Отрицательный margin компенсирует padding, чтобы не увеличивать высоту сообщения
						.ai-chat-stop-button
							display: flex
							align-items: center
							justify-content: center
							margin: -8px -8px -8px 0
							padding: 8px 12px
							border: none
							background: none
							outline: none
							box-shadow: none
							cursor: pointer
							line-height: 1

							i.fa
								color: #f86c6b
								font-size: 16px

							&:hover:not(:disabled) i.fa
								color: #ff3b3a

							&:disabled
								cursor: default
								opacity: 0.4

</style>
